module.exports = __webpack_public_path__ + "img/content.0497f405.svg";